<template>
  <div class="countier">
    <div class="search">
      <van-search v-model="searchText" shape="round" show-action background="#fff" placeholder="请输入您要搜索的商品名称"
        @search="onSearch(searchText)" @cancel="onCancel" @clear="onClear" />
    </div>
    <div class="zhan"></div>
    <div v-if="isShow">
      <div class="hestort_search">
        <div class="history_left">历史搜索</div>
        <qdd-icon class="iconshanchu1" color="#ccc" size=".6rem" @click="dele"></qdd-icon>
      </div>
      <!-- 搜索历史 -->
      <div class="hui_m" v-if="noHistory">
        <div class="search_history" v-for="(item, index) in searchHistories" :key="index" @click="onSearch(item)">
          <i class="history_txt">{{item}}</i>
        </div>
      </div>
      <div class="noHistory" v-else>暂时没有历史记录</div>
    </div>
    <div class="hui_m" v-else-if="!isShow && orderList.length>0">
      <!-- <div class="box" v-for="gods in orderList" :key="gods.stock_id" @click="jump(gods.stock_id)">
        <div class="img">
          <img :src="gods.goods_image" alt />
        </div>
        <div class="m_title">{{gods.goods_name}}</div>
        <div class="m_price">
          <i>{{gods.jinbi}}</i>
          <p class="integral">积分</p>
        </div>
      </div> -->
      <van-list v-model="loading" :finished="finished" :immediate-check="false" @load="onLoad" :offset="10">
        <!-- 列表 -->
        <ul class="goodsList">
          <li v-for="(item,index) in orderList" :key="index">
            <!-- 订单状态 -->
            <div class="status flex_b">
              <div>
                <qdd-icon class="iconjishi" color="#333" size=".5rem"></qdd-icon>
                <span class="ml10">{{item.add_time_format}}</span>
              </div>

              <div class="red" v-show="item.status == 20">待发货</div>
              <div class="red" v-show="item.status == 30">待收货</div>
              <div class="red" v-show="item.status == 40 && item.goods_type == 2">待确认</div>
              <div class="red"
                v-show="(item.goods_type == 2 && item.status == 41) || (item.goods_type != 2 && (item.status == 41 || item.status == 40))">
                已完成</div>
              <div class="red" v-show="item.status == 0 || item.status == 11">已取消</div>
              <div class="red" v-show="item.status == 10">已提交</div>
            </div>
            <!-- 商品 -->
            <div class="goods flex" @click='goDetail(item.id,item.xhq_id)'>
              <img :src="item.goods_image" alt="" />
              <div class="right_con">
                <p class="t_line2 goods_name">{{item.goods_name}}</p>
                <div class="gray" v-if="item.specification != ''">规格：{{item.specification}}</div>
                <div class="flex_b ">
                  <div class="jifen flex">
                    <span class="red">{{item.price_format}}</span>

                  </div>
                  <div class="gray">X{{item.quantity}}</div>
                </div>
              </div>
            </div>
            <!-- 合计 -->
            <div class="total">
              合计
              <span class="red">{{item.order_total_amount_format}}</span>
              (含运费{{item.shipping_fee_format}})
            </div>
            <!-- 底部按钮 -->
            <div class="footer" v-if='item.status=="30" '>
              <!--		0222 暂时隐藏确认收货和支付功能一起上	-->
              <div class="toPay" v-if='item.status == "30" && item.goods_type ==1'
                @click='goAffirm(item.id,item.goods_type)'>确认收货</div>

              <!-- <div class="toPay" v-if='item.status == "40" && item.goods_type ==2' @click='goAffirm(item.id,item.goods_type)'>确认兑换</div> -->
            </div>
          </li>
        </ul>
      </van-list>
      <p class="null_title_x" v-show="isShowTitle && orderList.length">没有更多了</p>
    </div>
    <div class="hui_m" v-else-if="!isShow && orderList.length==0">
      <div class="search_que">
        <img :src="ossImgPath + 'searchqsy.png'" />
      </div>
    </div>
  </div>
</template>

<script>
  import icon from '../../components/iconfont.vue';
  import { getItem, setItem, removeItem } from '../../utils/storage.js'
  import { sendRequest } from '../../assets/public'
  import { Dialog, Toast } from 'vant';
  export default {
    components: {
      "qdd-icon": icon
    },
    data() {
      return {
        searchText: '',
        searchHistories: getItem('search-order') || [], // 搜索历史记录
        suggestions: [],
        orderList: [],//商品列表
        isShow: true,
        noHistory: true,
        page: 1,
        isOnload: true,

        loading: false,
        finished: false,
        isShowTitle: false,
      };
    },

    mounted() {
      // this.getGods()
      // window.addEventListener('scroll', this.handScroll)

    },
    // 监视只有运行的是当前页面才工作
    methods: {
      async onSearch(q) {
        this.page = 1
        this.orderList = []
        this.noHistory = true
        this.searchText = q
        this.getGods()
        this.isShow = false

        if (q.match(/^[ ]*$/)) { return }
        // 记录历史记录
        const searchHistories = this.searchHistories
        const index = searchHistories.findIndex(item => {
          // 忽略空格、大小写
          return item.trim().toLowerCase() === q.trim().toLowerCase()
        })
        // 如果已存在，则将其移除
        if (index !== -1) {
          searchHistories.splice(index, 1)
        }
        // 将最新搜索记录保存到最前面
        searchHistories.unshift(q)
        setItem('search-order', searchHistories)
      },

      async getGods() {
        this.isShowTitle = false;
        const { content, status, msg } = await sendRequest('order/list', {
          goods_name: this.searchText,
          page: this.page,
          limit: 6
        })
        if (status != 200) {
          return
        } else {
          // if (content.list.length == 0) {
          //   this.isOnload = false
          //   return
          // }
          if (content.list.length < 6) { this.isShowTitle = true; }

          let shopData = [...this.orderList, ...content.list];
          this.orderList = shopData;
          this.loading = false;
          this.finished = content.list.length == 0;

        }
      },
      onLoad() {
        this.page++;
        this.getGods();
      },
      goDetail(id, xh_id) {
        this.$router.push({ name: 'orderDetails', query: { oderId: id, xh_id: xh_id } })
      },

      onCancel() {
        this.isShow = true
        this.searchText = ''
      },
      onClear() {

        this.isShow = true

      },
      // 删除历史记录
      dele() {
        Dialog.confirm({
          message: '确定删除历史内容吗？',
        }).then(() => {
          removeItem('search-order')
          this.searchHistories = []
          this.noHistory = false
        });

      },
      goAffirm(id, goodsType) {
        let _this = this;
        Dialog.confirm({
          message: '您是否确认收货？',
          confirmButtonText: '确定',
          confirmButtonColor: '#FD3E3E'
        })
          .then(() => {

            _this.getHuo(id)
            // on confirm
          })
          .catch(() => {
            // on cancel
          });

      },
      async getHuo(id) {
        let _this = this;
        let { content, status, msg } = await sendRequest('order/confirm', {
          order_id: id,
          type: this.iskey,
        })
        if (status == '200') {
          Toast('确认收货成功')
          setTimeout(function () {
            _this.$router.push({ path: '/order', query: { type: 40 } })
          }, 2000)
        } else {
          Toast(msg)
        }
      }

    }
  }
</script>

<style scoped>
  .null_title_x {
    font-size: .48rem;
    color: #333;
    text-align: center;
    margin: 0 auto;
  }

  .search_que {
    margin: 4rem auto 0;
  }

  .search_que img {
    width: 7.56rem;
  }


  .search {
    width: 100%;
    /* height: 100%; */
    position: fixed;
    top: 0;
  }

  .zhan {
    height: 2.6rem;
  }

  img {
    width: 7.48rem;
    height: 7.48rem;
    margin: 0 auto;
    display: block;
  }

  .noHistory {
    margin-top: 0.6rem;
    font-size: 0.6rem;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(171, 171, 171, 1);
    text-align: center;
    padding: 1rem 0;
  }

  .countier {
    /* position: fixed;
  width: 100%;
  height: 100%;
  top: 0px; */
    background-color: #ffffff;
  }

  .hestort_search {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.2rem 0.6rem;
  }

  .history_left {
    font-size: 0.52rem;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(153, 153, 153, 1);
  }

  .search_history {
    height: 0.6rem;
    padding: 0.2rem 0.6rem;
    background: #f6f5f8;
    text-align: center;
    padding: 0.16rem 0.4rem;
    border: 1px solid rgba(221, 221, 221, 1);
    border-radius: 0.54rem;
    font-size: 0.44rem;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    background: #fff;
    margin: 0.2rem;
  }

  .hui_m {
    display: flex;
    flex-wrap: wrap;
    padding: 0.2rem;
    background: #f6f5f8;
  }

  /* 搜索有结果 */
  .img {
    width: 4.6rem;
    height: 4.6rem;
    background: black;
    margin: 0 auto;
  }

  .m_title {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    overflow: hidden;
    /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    font-size: 0.48rem;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    margin-top: 0.64rem;
  }

  .m_price {
    display: flex;
    margin-top: 0.2rem;
    margin-left: 0.2rem;
  }

  .m_price i {
    font-size: 0.6rem;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(253, 62, 62, 1);
  }

  .integral {
    padding: 0.1rem 0.2rem;
    height: 0.52rem;
    line-height: 0.52rem;
    text-align: center;
    border: 1px solid rgba(253, 62, 62, 1);
    border-radius: 0.26rem;
    font-size: 0.36rem;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(253, 62, 62, 1);
    /* margin-top: .7rem; */
    margin-left: 0.2rem;
  }

  .box {
    width: 6.9rem;
    /* height: 7.84rem; */
    background: #fff;
    border-radius: 0.2rem;
    margin-left: 0.4rem;
    margin-bottom: 0.4rem;
    padding: 0.4rem 0;
  }

  .goodsList {
    /* margin-top: 4rem; */
    width: 14.2rem;
    margin: 0 auto;
  }

  .goodsList li {
    background: #fff;
    margin-bottom: 0.4rem;
  }

  .total {
    text-align: right;
    font-size: 0.48rem;
    padding: 0.4rem 0;
    border-top: 1px solid #dddddd;
    margin: 0 0.8rem;
  }

  .total span {
    font-size: 0.72rem;
    font-weight: bold;
    margin: 0 0.12rem;
  }

  .status {
    font-size: 0.56rem;
    margin: 0 0.8rem;
    border-bottom: 1px solid #dddddd;
    height: 1.76rem;
    line-height: 1.76rem;
  }

  .ml10 {
    margin-left: 0.2rem;
  }

  .my_tab {
    width: 100%;
    background: #fff;
    height: 1.88rem;
    line-height: 1.88rem;
    position: fixed;
    top: 0;
  }

  .my_tab .tab_ul_box {
    display: flex;
    justify-content: space-around;
    color: #999999;
    font-size: 0.56rem;
    height: 1.76rem;
  }

  .my_tab .tab_ul_box li {
    width: 1.72rem;
    text-align: center;
    border-bottom: 0.08rem solid transparent;
  }

  .my_tab .tab_ul_box li.active {
    color: #333333;
    border-bottom: 0.08rem solid #FD3E3E;
  }

  .gray {
    font-size: 0.48rem;
    color: #999;
  }

  .goods {
    background: #ffffff;
    padding: 0.4rem 0.8rem;
  }

  .goods img {
    width: 4rem;
    height: 4rem;
  }

  .right_con {
    width: 8.66rem;
    margin-left: 0.8rem;
    text-align: left;
  }

  .goods_name {
    font-size: 0.6rem;
    font-weight: 500;
    margin-bottom: 0.4rem;
  }

  .right_con .flex_b {
    margin-top: 0.6rem;
  }

  .right_con .flex_b .gray {
    line-height: 0.86rem;
  }

  .jifen .red {
    font-size: 0.72rem;
    font-weight: bold;
  }

  .badge {
    font-size: 0.4rem;
    color: #fd3e3e;
    border: 1px solid #fd3e3e;
    border-radius: 0.4rem;
    padding: 0.05rem 0.24rem;
    display: inline-block;
    margin-left: 0.12rem;
  }

  .footer {
    background: #ffffff;
    padding: 0.4rem 0.8rem;
    overflow: hidden;
  }

  .footer div {
    width: 3.8rem;
    height: 1.2rem;
    line-height: 1.2rem;
    text-align: center;
    font-size: 0.56rem;
    float: right;
    margin-left: 0.4rem;
    border-radius: 0.6rem;
  }

  .toPay {
    background: #fd3e3e;
    color: #fff;
    border: 1px solid #fd3e3e;
  }

  .cancel {
    color: #999999;
    border: 1px solid #999;
  }
</style>